import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Frontend from './layout/Frontend';
import Home from './pages/Home';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
  <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
